import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const BlogHero = () => {
  return (
    <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden bg-gradient-to-br from-background via-primary/5 to-accent/10">
      {/* 3D Background Elements */}
      <div className="absolute inset-0 perspective-1000">
        <motion.div
          className="absolute top-20 left-10 w-32 h-32 bg-accent/10 rounded-full blur-xl"
          animate={{
            y: [0, -20, 0],
            rotate: [0, 180, 360],
          }}
          transition={{
            duration: 8,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
        <motion.div
          className="absolute bottom-20 right-10 w-24 h-24 bg-success/10 rounded-lg blur-lg"
          animate={{
            y: [0, 20, 0],
            rotate: [0, -180, -360],
          }}
          transition={{
            duration: 6,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
        <motion.div
          className="absolute top-1/2 left-1/2 w-16 h-16 bg-warning/10 rounded-full blur-md transform -translate-x-1/2 -translate-y-1/2"
          animate={{
            scale: [1, 1.2, 1],
            rotate: [0, 90, 180, 270, 360],
          }}
          transition={{
            duration: 10,
            repeat: Infinity,
            ease: "linear"
          }}
        />
      </div>
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mb-6"
        >
          <div className="inline-flex items-center space-x-2 bg-accent/10 text-accent px-4 py-2 rounded-full text-sm font-medium mb-6">
            <Icon name="BookOpen" size={16} />
            <span>Knowledge Hub</span>
          </div>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-4xl md:text-6xl lg:text-7xl font-bold text-foreground mb-6 text-shadow-3d"
        >
          Blog <span className="text-accent">Universe</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="text-lg md:text-xl text-muted-foreground mb-8 max-w-2xl mx-auto leading-relaxed"
        >
          Explore cutting-edge insights, technical tutorials, and industry trends through immersive storytelling and interactive learning experiences.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6"
        >
          <div className="flex items-center space-x-2 text-muted-foreground">
            <Icon name="Users" size={16} />
            <span className="text-sm">10K+ Developers</span>
          </div>
          <div className="flex items-center space-x-2 text-muted-foreground">
            <Icon name="FileText" size={16} />
            <span className="text-sm">200+ Articles</span>
          </div>
          <div className="flex items-center space-x-2 text-muted-foreground">
            <Icon name="TrendingUp" size={16} />
            <span className="text-sm">Weekly Updates</span>
          </div>
        </motion.div>
      </div>
      {/* Floating Code Elements */}
      <motion.div
        className="absolute top-1/4 left-1/4 opacity-20"
        animate={{
          y: [0, -10, 0],
          rotate: [0, 5, -5, 0],
        }}
        transition={{
          duration: 4,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      >
        <div className="bg-card/50 backdrop-blur-sm border border-border rounded-lg p-3">
          <code className="text-accent text-xs font-mono">
            const blog = () =&gt; magic
          </code>
        </div>
      </motion.div>
      <motion.div
        className="absolute bottom-1/4 right-1/4 opacity-20"
        animate={{
          y: [0, 10, 0],
          rotate: [0, -5, 5, 0],
        }}
        transition={{
          duration: 5,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      >
        <div className="bg-card/50 backdrop-blur-sm border border-border rounded-lg p-3">
          <code className="text-success text-xs font-mono">
            &lt;Innovation /&gt;
          </code>
        </div>
      </motion.div>
    </section>
  );
};

export default BlogHero;